"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoSagas = exports.watchOnPlayerClick = exports.setOverlayActive = exports.watchOnPlaylistClick = exports.watchOnEnded = exports.watchTotalTimeChanged = exports.watchCurrentTimeChanged = exports.watchMutedToggle = exports.watchPlayToggle = exports.watchInputRangeChangeEnd = exports.watchInputRangeChange = exports.watchInputRangeChangeStart = void 0;
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
var effects_1 = require("redux-saga/effects");
exports.watchInputRangeChangeStart = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_CHANGE_START)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setIsPlaying(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchInputRangeChange = function () {
    var payload, newCurrent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_CHANGE)];
            case 1:
                payload = (_a.sent()).payload;
                newCurrent = payload;
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setCurrentTime(newCurrent))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchInputRangeChangeEnd = function () {
    var payload, newCurrent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_CHANGE_END)];
            case 1:
                payload = (_a.sent()).payload;
                newCurrent = payload;
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setTargetCurrent(newCurrent))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setIsPlaying(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.watchPlayToggle = function (selector) { return function () {
    var isPlaying;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_PLAY_TOGGLE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(selector.getIsPlaying)];
            case 2:
                isPlaying = _a.sent();
                if (!isPlaying) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoPlayerOverlayActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoPlayerOverlayActive(false))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, effects_1.put(VideoAction_1.default.setIsPlaying(!isPlaying))];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
}; };
exports.watchMutedToggle = function (selector) { return function () {
    var isMuted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_MUTED_TOGGLE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(selector.getIsMuted)];
            case 2:
                isMuted = _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setIsMuted(!isMuted))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
}; };
exports.watchCurrentTimeChanged = function () {
    var payload, currentTime;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_CURRENT_TIME_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                currentTime = payload;
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setCurrentTime(currentTime))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchTotalTimeChanged = function () {
    var payload, totalTime;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_TOTAL_TIME_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                totalTime = payload;
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setTotalTime(totalTime))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchOnEnded = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_ENDED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setCurrentTime(0))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setIsPlaying(false))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.watchOnPlaylistClick = function () {
    var payload, video;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_PLAYLIST_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                video = payload;
                return [4 /*yield*/, effects_1.call(exports.setOverlayActive, true)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setIsPlaying(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoId(video.src))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoTitleCaption(video.title, video.caption))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
exports.setOverlayActive = function (isActive) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoPlayerOverlayActive(isActive))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.watchOnPlayerClick = function (selector) { return function () {
    var isPlaying, isOverlayActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(VideoAction_1.default.DETAIL_VIDEO_ON_PLAYER_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(selector.getIsPlaying)];
            case 2:
                isPlaying = _a.sent();
                return [4 /*yield*/, effects_1.select(selector.getIsOverlayActive)];
            case 3:
                isOverlayActive = _a.sent();
                if (!(isPlaying && !isOverlayActive)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(exports.setOverlayActive, true)];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(VideoAction_1.default.onPlayToggle())];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
}; };
exports.videoSagas = function (selector) { return ({
    watchInputRangeChangeStart: exports.watchInputRangeChangeStart,
    watchInputRangeChange: exports.watchInputRangeChange,
    watchInputRangeChangeEnd: exports.watchInputRangeChangeEnd,
    watchPlayToggle: exports.watchPlayToggle(selector),
    watchMutedToggle: exports.watchMutedToggle(selector),
    watchCurrentTimeChanged: exports.watchCurrentTimeChanged,
    watchTotalTimeChanged: exports.watchTotalTimeChanged,
    watchOnEnded: exports.watchOnEnded,
    watchOnPlaylistClick: exports.watchOnPlaylistClick,
    watchOnPlayerClick: exports.watchOnPlayerClick(selector),
}); };
